export const environment = {
  production: false,
  apiUrl: "https://server.dev2.bdomobile.com/",
  keycloakUrl: "https://keycloak-dev.mobiletract.com",
  realm: "bdo-dev2",
  tpayScript: "https://secure.tpay.com/groups-696041.js",
  clientId: "ekowitryna_admin_panel",
  googleTagManagerId: 'GTM-T43SC6BD',
  googleTagManagerPreview: 'env-3',
  googleTagManagerAuth: 'nwRCCNlB1-SPt0eiDeFIOw',
  otp: true,
  subscriptions: false,
  subscriptionCatalog: false,
  newADM: false,
  enableDebugControls: true,
  signozUrl: "https://otlp.monitoring.mobiletract.com",
  signozEnv: "dev2",
  signozServiceName: "ekowitryna-admin-panel_web",
  platformWebUrl: "https://platforma.dev2.bdomobile.com",
  allowedReturnUrlOrigins: [
    'https://platforma.dev2.bdomobile.com',
    'https://panel.dev2.bdomobile.com',
    'https://kobize.ekowitryna.pl',
    'https://esg.dev2.bdomobile.com',
    'http://localhost:4200',
  ],
};
